import DOMReady from './domready.js';
window.DOMReady = DOMReady;

import Cookies from './cookies.min.js';
window.Cookies = Cookies;

import currentuser from './user.js';
window.currentuser = currentuser;
DOMReady( function(){
  currentuser.init();
});

require('./header-sticky.js'); //Remove JQuery : OK
require('./header-abodropdown.js'); //Remove JQuery : OK
require('./burgermenu.js'); //Remove JQuery : OK
require('./tracking.js'); //Remove JQuery : OK
require('./smoothscroll.js'); //Remove JQuery : OK
require('./abodisplay.js'); //Remove JQuery : OK
require('./account.js'); //Remove JQuery : OK
require('./form-search.js'); //Remove JQuery : OK
require('./comment.js'); //Remove JQuery : OK
require('./newsletters.js'); //Remove JQuery : OK
require('./pagination.js'); //Remove JQuery : OK
require('./rgpd/content-mask.js'); //Remove JQuery : OK
require('./rgpd/removecookies.js'); //Remove JQuery : OK
require('./content/view/parts/map.js'); //Remove JQuery : OK
require('./content/view/parts/sharelink.js'); //Remove JQuery : OK
require('./content/view/parts/carousel.js'); //Remove JQuery : OK
require('./content/view/parts/bookmark.js'); //Remove JQuery : OK
require('./content/view/parts/puzzle.js'); //Remove JQuery : OK
require('./content/view/parts/sondage.js'); //Remove JQuery : OK
require('./content/view/parts/panorama.js'); //Remove JQuery : OK
require('./content/view/parts/btn-print.js'); //Remove JQuery : OK
require('./content/view/parts/coloriage.js'); //Remove JQuery : OK
require('./content/view/parts/diaporama.js'); //Remove JQuery : OK
require('./content/view/parts/live.js'); //Remove JQuery : OK
require('./content/view/parts/event.js'); //Remove JQuery : OK
require('./content/view/parts/locationview.js'); //Remove JQuery : OK
require('./content/view/parts/authors.js'); //Remove JQuery : OK
require('./content/view/parts/cartouches.js'); //Remove JQuery : OK
require('./content/view/parts/more-contents.js'); //Remove JQuery : OK
require('./content/view/parts/form-game.js'); //Remove JQuery : OK
require('./content/view/parts/zoom-diapo.js'); //Remove JQuery : OK
require('./admin-edit.js'); //Remove JQuery : OK
require('./darkmode.js'); //Remove JQuery : OK
require('./info-block.js'); //Remove JQuery : OK
require('./zoom.js'); //Remove JQuery : OK
require('./grossesse.js'); //Remove JQuery : OK
require('./overridelink.js'); //Remove JQuery : OK
